<template>
    <div class="page-content">
        <div class="page-body">
            <div class="page-body-top">
                <img class="top-img" src="./../assets/img/detailB.jpg" alt="">
                <div class="top-content">
                    <img v-if="detail.landlord.portrait" class="user-head" :src="`/api/v1/file/${detail.landlord.portrait}`" alt="">
                    <div class="mr-a">
                        <div class="f-18 fw-b mb-6">{{detail.landlord.nickname}}</div>
                        <div class="f-14 color-grays">{{detail.landlord.city}} 注册时间：{{detail.landlord.created_at}}</div>
                    </div>
                    <el-popover
                            placement="bottom-start"
                            title="分享"
                            width="200"
                            trigger="hover">
                        <div slot="reference" class="title-right">
                            <i class="el-icon-share"></i>
                            分享
                        </div>
                        <div data-sites="qzone, qq, weibo, wechat" class="social-share"></div>
                    </el-popover>
                </div>
            </div>
            <div class="content-body">
                <div class="content-title">个人介绍</div>
                <div class="content-text" v-html="newBio||'暂无介绍~'"></div>
                <div v-if="newBio" class="color-grays f-14 mt-10 mb-10 tran-content">
                    是否使用谷歌翻译
                    <template v-if="!traning">
                        <el-link class="ml-20" type="primary" @click="trans('zh')">翻译为中文</el-link>
                        <el-link class="ml-10" type="primary" @click="trans('jp')">翻译为日文</el-link>
                    </template>
                    <el-link v-else class="ml-10" type="primary">翻译中...</el-link>
                </div>

                <div class="content-text" v-for="(item,index) in transList" :key="index">{{item.dst}}</div>

                <div class="content-title">精通语言</div>
                <div class="content-text">{{detail.landlord.language}}</div>

                <div class="content-title">家乡</div>
                <div class="content-text">{{detail.landlord.country}} {{detail.landlord.city}}</div>

            </div>
            <div class="content-body" style="padding-left: 0;padding-right: 0;">
                <div class="content-title ml-30">ta的房源</div>
                <div class="card-content" style="width: 100%;">
                    <HouseCard v-for="(item,index) in detail.house" :key="index" :item="item"></HouseCard>
                </div>
            </div>
            <div class="content-body">
                <div class="content-title">用户评价</div>
                <div style="display: flex;justify-content: space-between;align-items: center">
                    <el-rate :value="detail.landlord.star"
                             disabled
                             show-score
                             disabled-void-color="#cccccc"
                             text-color="#ff9900"
                             style="display: flex;justify-content: flex-start;align-items: center"
                             score-template="{value}"></el-rate>
                    <div class="f-14 color-grays">{{detail.landlord.landlord_count}}评价</div>
                </div>

                <CommentItem class="mt-20" v-for="item in detail.landlord.evaluate"
                              :key="item.id"
                              :star="item.star"
                              :name="item.nickname"
                              :text="item.assess"
                              :time="item.created_at"
                              :head="item.portrait"></CommentItem>
            </div>
        </div>
    </div>
</template>

<script>
    import HouseCard from "../components/HouseCard";
    import CommentItem from "../components/CommentItem";

    export default {
        name: "driverDetail",
        components:{HouseCard, CommentItem},
        data() {
            return {
                traning: false,
                transList: [],
                user_id: '',
                detail:{
                    landlord: {},
                    house: []
                },
                config: {
                    title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
                    description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
                    image: '', // 图片, 默认取网页中第一个img标签
                    sites: ['qzone', 'qq', 'weibo', 'wechat']
                }
            }
        },
        mounted() {
            this.user_id = this.$route.query.id;
            this.landlordLandlord();
        },
        computed:{
            newBio(){
                if(this.detail.landlord.bio){
                    return this.detail.landlord.bio.replace(/\n/g, '<br/>')
                }
                return ''
            }
        },
        methods: {
            async trans(to) {
                this.traning = true;
                let [e, data] = await this.$api.transApi({to, q: this.detail.landlord.bio})
                this.traning = false;
                this.transList = data.result;
            },
            async landlordLandlord() {
                let [e, data] = await this.$api.landlordLandlordApi({landlord_id: this.user_id})
                this.detail = data.result;
                socialShare('.social-share', this.config)
            }
        },
    }
</script>

<style scoped lang="less">
    .page-content{
        padding: 20px;
    }
    .page-body{
        width: 900px;
        box-shadow: 3px 3px 6px #A6A6A6;
        margin: auto;
        background-color: #ffffff;
    }
    .page-body-top{
        width: 100%;
        border-bottom: 1px solid #e2e2e2;
        .top-img{
            width: 100%;
            height: 118px;
            object-fit: cover;
        }
        .top-content{
            width: 100%;
            padding-left: 160px;
            padding-right: 20px;
            padding-bottom: 20px;
            height: 80px;
            box-sizing: border-box;
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .user-head{
                position: absolute;
                width: 100px;
                height: 100px;
                border-radius: 100%;
                left: 0;
                bottom: 0;
                transform: translate(30px, -20px);
                object-fit: cover;
            }
        }
    }
    .content-body {
        padding: 10px 30px 30px 30px;
        box-sizing: border-box;
        width: 100%;
        text-align: left;
        border-bottom: 1px solid #e2e2e2;
    }
    .content-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 20px;
        text-align: left;
        box-sizing: border-box;
    }

    .content-text {
        font-size: 14px;
        line-height: 2;
    }
</style>
